import React from 'react';
import { Grid, GridRow, GridColumn } from '@react/react-spectrum/Grid';
import productPath from '../productPath.json';
import ComboBoxComponent from './Combobox';
import ProductsTable from './ProductsTable';
import Heading from '@react/react-spectrum/Heading';

const align = {
  xs: 'left',
  sm: 'left',
  md: 'left'
};

const comboAlign = {
  xs: 'center',
  sm: 'center',
  md: 'center'
};

const style = {
  position: 'relative',
  boxSizing: 'border-box',
  minHeight: '2.25rem',
  padding: '10px'
};

export default class DropdownSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adobeProducts: productPath.products
    };
  }

  render() {
    return (
      <Grid>
        <GridRow align={align}>
          <GridColumn size={2}> </GridColumn>
          <GridColumn size={8}>
            <div style={style}>
              <Heading>Getting started</Heading>
              <p>
                Find where to ask questions, report bugs, make feature requests,
                and spark discussions for all Adobe products. You can get
                started by <b>typing a product name</b> into the search,{' '}
                <b>scrolling through the dropdown</b>, or{' '}
                <b>browsing all products</b> in the list below.
              </p>
            </div>
          </GridColumn>
          <GridColumn size={2}> </GridColumn>
        </GridRow>
        <GridRow align={comboAlign}>
            <GridColumn size={2}></GridColumn>
            <GridColumn size={8}>
              <div style={style}>
                <ComboBoxComponent products={this.state.adobeProducts} />
              </div>
            </GridColumn>
            <GridColumn size={2}></GridColumn>
        </GridRow>
        <GridRow align={align}>
          <GridColumn size={2}> </GridColumn>
          <GridColumn size={8}>
            <div style={style}>
              <Heading variant="pageTitle">All Products</Heading>
            </div>
          </GridColumn>
          <GridColumn size={2}> </GridColumn>
        </GridRow>
        <ProductsTable
          products={this.state.adobeProducts}
          align={align}
          style={style}
        />
      </Grid>
    );
  }
}
